
const comunidades = [
    {
        name: "Andalucía",
        code: 1
    },
    {
        name: "Aragón",
        code: 2
    },
    {
        name: "Principado de Asturias",
        code: 3
    },
    {
        name: "Illes Baleares",
        code: 4
    },
    {
        name: "Canarias",
        code: 5
    },
    {
        name: "Cantabria",
        code: 6
    },
    {
        name: "Castilla y León",
        code: 7
    },
    {
        name: "Castilla- La Mancha",
        code: 8
    },
    {
        name: "Cataluña",
        code: 9
    },
    {
        name: "Comunitat Valenciana",
        code: 10
    },
    {
        name: "Extremadura",
        code: 11
    },
    {
        name: "Galicia",
        code: 12
    },
    {
        name: "Comunidad de Madrid",
        code: 13
    },
    {
        name: "Región de Murcia",
        code: 14
    },
    {
        name: "Comunidad Foral de Navarra",
        code: 15
    },
    {
        name: "País Vasco",
        code: 16
    },
    {
        name: "La Rioja",
        code: 17
    },
    {
        name: "Ciudad Autónoma de Ceuta",
        code: 18
    },
    {
        name: "Ciudad Autónoma de Melilla",
        code: 19
    },
];

export default  comunidades;
